module.exports = __webpack_public_path__ + "img/database.4f216c28.svg";